import { SHOW_DIALOG, HIDE_DIALOG } from '../constants/action-types';
export const DEFAULT_STATE = {
    dialogProps: null,
    type: null,
};
// eslint-disable-next-line @typescript-eslint/default-param-last
export const activeDialog = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SHOW_DIALOG:
            return action.payload;
        case HIDE_DIALOG:
            return DEFAULT_STATE;
        default:
            return state;
    }
};
